export default {
  default: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/layouts/default.vue").then(m => m.default || m),
  leader: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/layouts/leader.vue").then(m => m.default || m),
  manage: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/layouts/manage.vue").then(m => m.default || m),
  noheader: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/layouts/noheader.vue").then(m => m.default || m)
}